// API Service for ZenIO Panel
// Replace YOUR-API-ID with your actual API Gateway ID after deployment

const API_BASE_URL = 'https://ssso0a02dk.execute-api.us-west-1.amazonaws.com/prod';

// For development/testing, you can temporarily use this:
// const API_BASE_URL = 'http://localhost:3001/api';

export const api = {
  // ========== Authentication ==========
  
  async login(username, password) {
    try {
      const response = await fetch(`${API_BASE_URL}/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password })
      });
      
      if (!response.ok) {
        throw new Error('Login failed');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Login error:', error);
      throw error;
    }
  },

  async googleLogin(credential) {
    try {
      const response = await fetch(`${API_BASE_URL}/google-login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ credential })
      });
      
      if (!response.ok) {
        throw new Error('Google login failed');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Google login error:', error);
      throw error;
    }
  },

  // ========== User Management ==========
  
  async getUsers() {
    try {
      const response = await fetch(`${API_BASE_URL}/users`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      
      if (!response.ok) {
        throw new Error('Failed to fetch users');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Get users error:', error);
      throw error;
    }
  },

  async createUser(userData) {
    try {
      const response = await fetch(`${API_BASE_URL}/users`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(userData)
      });
      
      if (!response.ok) {
        throw new Error('Failed to create user');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Create user error:', error);
      throw error;
    }
  },

  async updateUser(userId, userData) {
    try {
      const response = await fetch(`${API_BASE_URL}/users/${userId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(userData)
      });
      
      if (!response.ok) {
        throw new Error('Failed to update user');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Update user error:', error);
      throw error;
    }
  },

  async deleteUser(userId) {
    try {
      const response = await fetch(`${API_BASE_URL}/users/${userId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      
      if (!response.ok) {
        throw new Error('Failed to delete user');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Delete user error:', error);
      throw error;
    }
  },

  // ========== Site Permissions ==========
  
  async getUserSitePermissions(userId) {
    try {
      const response = await fetch(`${API_BASE_URL}/users/${userId}/site-permissions`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      
      if (!response.ok) {
        throw new Error('Failed to get site permissions');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Get site permissions error:', error);
      throw error;
    }
  },

  async updateUserSitePermissions(userId, enabledSites) {
    try {
      const response = await fetch(`${API_BASE_URL}/users/${userId}/site-permissions`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ enabledSites })
      });
      
      if (!response.ok) {
        throw new Error('Failed to update site permissions');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Update site permissions error:', error);
      throw error;
    }
  },

  // ========== Site Management ==========
  
  async getSites() {
    try {
      const response = await fetch(`${API_BASE_URL}/sites`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      
      if (!response.ok) {
        throw new Error('Failed to fetch sites');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Get sites error:', error);
      throw error;
    }
  },

  async createSite(siteData) {
    try {
      const response = await fetch(`${API_BASE_URL}/sites`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(siteData)
      });
      
      if (!response.ok) {
        throw new Error('Failed to create site');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Create site error:', error);
      throw error;
    }
  },

  async updateSite(siteId, siteData) {
    try {
      const response = await fetch(`${API_BASE_URL}/sites/${siteId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(siteData)
      });
      
      if (!response.ok) {
        throw new Error('Failed to update site');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Update site error:', error);
      throw error;
    }
  },

  async deleteSite(siteId) {
    try {
      const response = await fetch(`${API_BASE_URL}/sites/${siteId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      
      if (!response.ok) {
        throw new Error('Failed to delete site');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Delete site error:', error);
      throw error;
    }
  },

  // ========== Employee Management ==========
  
  async getEmployees() {
    try {
      const response = await fetch(`${API_BASE_URL}/employees`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      
      if (!response.ok) {
        throw new Error('Failed to fetch employees');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Get employees error:', error);
      throw error;
    }
  },

  async createEmployee(employeeData) {
    try {
      const response = await fetch(`${API_BASE_URL}/employees`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(employeeData)
      });
      
      if (!response.ok) {
        throw new Error('Failed to create employee');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Create employee error:', error);
      throw error;
    }
  },

  async updateEmployee(employeeId, employeeData) {
    try {
      const response = await fetch(`${API_BASE_URL}/employees/${employeeId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(employeeData)
      });
      
      if (!response.ok) {
        throw new Error('Failed to update employee');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Update employee error:', error);
      throw error;
    }
  },

  async deleteEmployee(employeeId) {
    try {
      const response = await fetch(`${API_BASE_URL}/employees/${employeeId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      
      if (!response.ok) {
        throw new Error('Failed to delete employee');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Delete employee error:', error);
      throw error;
    }
  },

  // ========== Time Tracking ==========
  
  async getTimeRecords(userId) {
    try {
      const response = await fetch(`${API_BASE_URL}/timetracking/${userId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      
      if (!response.ok) {
        throw new Error('Failed to fetch time records');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Get time records error:', error);
      throw error;
    }
  },

  async clockIn(userId) {
    try {
      const response = await fetch(`${API_BASE_URL}/timetracking/${userId}/clockin`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ timestamp: new Date().toISOString() })
      });
      
      if (!response.ok) {
        throw new Error('Failed to clock in');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Clock in error:', error);
      throw error;
    }
  },

  async clockOut(userId) {
    try {
      const response = await fetch(`${API_BASE_URL}/timetracking/${userId}/clockout`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ timestamp: new Date().toISOString() })
      });
      
      if (!response.ok) {
        throw new Error('Failed to clock out');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Clock out error:', error);
      throw error;
    }
  },

  async startBreak(userId) {
    try {
      const response = await fetch(`${API_BASE_URL}/timetracking/${userId}/startbreak`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ timestamp: new Date().toISOString() })
      });
      
      if (!response.ok) {
        throw new Error('Failed to start break');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Start break error:', error);
      throw error;
    }
  },

  async endBreak(userId) {
    try {
      const response = await fetch(`${API_BASE_URL}/timetracking/${userId}/endbreak`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ timestamp: new Date().toISOString() })
      });
      
      if (!response.ok) {
        throw new Error('Failed to end break');
      }
      
      return await response.json();
    } catch (error) {
      console.error('End break error:', error);
      throw error;
    }
  },

  // ========== Work Schedule ==========
  
  async getAllWorkSchedules() {
    try {
      const response = await fetch(`${API_BASE_URL}/workschedule`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      
      if (!response.ok) {
        throw new Error('Failed to fetch all work schedules');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Get all work schedules error:', error);
      throw error;
    }
  },
  
  async getWorkSchedule(userId) {
    try {
      const response = await fetch(`${API_BASE_URL}/workschedule/${userId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      
      if (!response.ok) {
        throw new Error('Failed to fetch work schedule');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Get work schedule error:', error);
      throw error;
    }
  },

  async updateWorkSchedule(userId, scheduleData) {
    try {
      const response = await fetch(`${API_BASE_URL}/workschedule/${userId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ schedule: scheduleData })
      });
      
      if (!response.ok) {
        throw new Error('Failed to update work schedule');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Update work schedule error:', error);
      throw error;
    }
  },

  // ========== Unavailability ==========
  
  async getAllUnavailability() {
    try {
      const response = await fetch(`${API_BASE_URL}/unavailability`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      
      if (!response.ok) {
        throw new Error('Failed to fetch all unavailability data');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Get all unavailability error:', error);
      throw error;
    }
  },
  
  async getUnavailability(userId) {
    try {
      const response = await fetch(`${API_BASE_URL}/unavailability/${userId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      
      if (!response.ok) {
        throw new Error('Failed to fetch unavailability');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Get unavailability error:', error);
      throw error;
    }
  },

  async updateUnavailability(userId, unavailabilityData) {
    try {
      const response = await fetch(`${API_BASE_URL}/unavailability/${userId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ unavailability: unavailabilityData })
      });
      
      if (!response.ok) {
        throw new Error('Failed to update unavailability');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Update unavailability error:', error);
      throw error;
    }
  }
};

// Helper function to check if API is configured
export const isAPIConfigured = () => {
  return !API_BASE_URL.includes('YOUR-API-ID');
};

// Helper function to use localStorage as fallback
export const useLocalStorageFallback = () => {
  return !isAPIConfigured();
};
